import { forwardRef } from 'react'
import { UseFormRegister } from 'react-hook-form'

interface TextoProps {
  label: string
  name: string
  placeholder?: string
  obrigatorio?: boolean
  register: UseFormRegister<any>
  error?: any
  tipo?: string
  className?: string
}

export const Texto = forwardRef<HTMLInputElement, TextoProps>(
  ({ label, name, placeholder, obrigatorio, register, error, tipo = "text", className = "" }, ref) => {
    const { ref: registerRef, ...registerProps } = register(name)
    
    return (
      <div className={`space-y-1 ${className}`}>
        <label className="block text-sm font-medium text-gray-700">
          {label}
          {obrigatorio && <span className="text-red-500 ml-1">*</span>}
        </label>
        <input
          type={tipo}
          placeholder={placeholder}
          {...registerProps}
          ref={(e) => {
            registerRef(e)
            if (typeof ref === 'function') {
              ref(e)
            } else if (ref) {
              ref.current = e
            }
          }}
          className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
            error ? 'border-red-500' : 'border-gray-300'
          }`}
        />
        {error && <p className="text-sm text-red-600">{error.message}</p>}
      </div>
    )
  }
)
